// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ProjectParticipant  {
    _originalTypeClassName = "Loom.BO.ProjectParticipant";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ProjectParticipant.translate = translateService;
}
this.WorkAssignments = [];
this.MilestonesLed = [];
this.ProjectTeam = [];
this.ProjectPayments = [];
this.Trips = [];
this.Id = null;
this.ParticipantNumber = null;
this.ShortName = null;
this.AccountingCode = null;
this.Caption = null;
this.Role = null;
this.PersonnelCosts_A1A2A3_actuals = null;
this.PersonnelCosts_A1A2A3_unit = null;
this.PersonnelCosts_A4_unit = null;
this.PersonnelCosts = null;
this.SubcontractingCosts = null;
this.OtherDirectCosts_TravelCosts = null;
this.OtherDirectCosts_Equipment = null;
this.OtherDirectCosts_OtherGoods = null;
this.OtherDirectCosts = null;
this.OtherCostCategories = null;
this.IndirectCosts = null;
this.TotalEstimatedEligibleCosts = null;
this.FundingRate = null;
this.MaxEUContribution = null;
this.RequestedEUContribution = null;
this.MaxGrantAmount = null;
this.TotalEffort = null;
this.EntryMonth = null;
this.ExitMonth = null;
this.PMRate = null;
this.ParticipantNumberDecimal = null;
this.EntryDate = null;
this.ExitDate = null;
this.ReportingStatus = null;
this.Sponsor = null;
this.LumpSumCosts = null;
this.FinancialContactEmail = null;
this.FinancialContactFullName = null;
this.UnitCostRate = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
ParticipantNumber:any;
ShortName:any;
AccountingCode:any;
Caption:any;
Role:any;
PersonnelCosts_A1A2A3_actuals:any;
PersonnelCosts_A1A2A3_unit:any;
PersonnelCosts_A4_unit:any;
PersonnelCosts:any;
SubcontractingCosts:any;
OtherDirectCosts_TravelCosts:any;
OtherDirectCosts_Equipment:any;
OtherDirectCosts_OtherGoods:any;
OtherDirectCosts:any;
OtherCostCategories:any;
IndirectCosts:any;
TotalEstimatedEligibleCosts:any;
FundingRate:any;
MaxEUContribution:any;
RequestedEUContribution:any;
MaxGrantAmount:any;
TotalEffort:any;
EntryMonth:any;
ExitMonth:any;
PMRate:any;
ParticipantNumberDecimal:any;
EntryDate:any;
ExitDate:any;
ReportingStatus:any;
Sponsor:any;
LumpSumCosts:any;
FinancialContactEmail:any;
FinancialContactFullName:any;
UnitCostRate:any;
Project:any;
Organisation:any;
WorkAssignments:any;
MilestonesLed:any;
ProjectTeam:any;
ProjectPayments:any;
Trips:any;
static setProject = ($this, value) => {
var oldValue = $this.Project;
$this.Project = value;
if (value != null) {
if (oldValue != null) {
Domain.Project.removeConsortium(oldValue, $this);
}
Domain.Project.addConsortium(value, $this);
}
}
static setOrganisation = ($this, value) => {
var oldValue = $this.Organisation;
$this.Organisation = value;
if (value != null) {
if (oldValue != null) {
Domain.Organisation.removeParticipationAsBeneficiary(oldValue, $this);
}
Domain.Organisation.addParticipationAsBeneficiary(value, $this);
}
}
static setWorkAssignments = ($this, items) => {
                if (items == null) items = [];
                if ($this.WorkAssignments == null) $this.WorkAssignments = [];

                const copyItems = Common.cloneObject(items);

                while ($this.WorkAssignments.length > 0) {
                    Domain.ProjectParticipant.removeWorkAssignments($this, $this.WorkAssignments[0]);
                }

                Domain.ProjectParticipant.addManyWorkAssignments($this, copyItems);
            }
static addManyWorkAssignments = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.ProjectParticipant.addWorkAssignments($this, items[i]);
                }
            }
static addWorkAssignments = ($this, item) => {
                if ($this.WorkAssignments == null) $this.WorkAssignments = [];
                if (item == null || $this.WorkAssignments.indexOf(item) > -1) return;
                $this.WorkAssignments.push(item);
if (item.Participant != $this) {
Domain.ParticipantWorkAssignment.setParticipant(item, $this);
}
}
static addRangeWorkAssignments = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.ProjectParticipant.addWorkAssignments($this, item));
            }
static removeWorkAssignments = ($this, item) => {
                if ($this == null || $this.WorkAssignments == null || $this.WorkAssignments.indexOf(item) === -1) return;
                var _index = $this.WorkAssignments.indexOf(item);
                $this.WorkAssignments.splice(_index, 1);
item.Participant = null;
}
static clearWorkAssignments = ($this) => { $this.WorkAssignments = null; }
static setMilestonesLed = ($this, items) => {
                if (items == null) items = [];
                if ($this.MilestonesLed == null) $this.MilestonesLed = [];

                const copyItems = Common.cloneObject(items);

                while ($this.MilestonesLed.length > 0) {
                    Domain.ProjectParticipant.removeMilestonesLed($this, $this.MilestonesLed[0]);
                }

                Domain.ProjectParticipant.addManyMilestonesLed($this, copyItems);
            }
static addManyMilestonesLed = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.ProjectParticipant.addMilestonesLed($this, items[i]);
                }
            }
static addMilestonesLed = ($this, item) => {
                if ($this.MilestonesLed == null) $this.MilestonesLed = [];
                if (item == null || $this.MilestonesLed.indexOf(item) > -1) return;
                $this.MilestonesLed.push(item);
if (item.Lead != $this) {
Domain.Milestone.setLead(item, $this);
}
}
static addRangeMilestonesLed = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.ProjectParticipant.addMilestonesLed($this, item));
            }
static removeMilestonesLed = ($this, item) => {
                if ($this == null || $this.MilestonesLed == null || $this.MilestonesLed.indexOf(item) === -1) return;
                var _index = $this.MilestonesLed.indexOf(item);
                $this.MilestonesLed.splice(_index, 1);
item.Lead = null;
}
static clearMilestonesLed = ($this) => { $this.MilestonesLed = null; }
static setProjectTeam = ($this, items) => {
                if (items == null) items = [];
                if ($this.ProjectTeam == null) $this.ProjectTeam = [];

                const copyItems = Common.cloneObject(items);

                while ($this.ProjectTeam.length > 0) {
                    Domain.ProjectParticipant.removeProjectTeam($this, $this.ProjectTeam[0]);
                }

                Domain.ProjectParticipant.addManyProjectTeam($this, copyItems);
            }
static addManyProjectTeam = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.ProjectParticipant.addProjectTeam($this, items[i]);
                }
            }
static addProjectTeam = ($this, item) => {
                if ($this.ProjectTeam == null) $this.ProjectTeam = [];
                if (item == null || $this.ProjectTeam.indexOf(item) > -1) return;
                $this.ProjectTeam.push(item);
if (item.ProjectParticipant != $this) {
Domain.ProjectTeamMember.setProjectParticipant(item, $this);
}
}
static addRangeProjectTeam = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.ProjectParticipant.addProjectTeam($this, item));
            }
static removeProjectTeam = ($this, item) => {
                if ($this == null || $this.ProjectTeam == null || $this.ProjectTeam.indexOf(item) === -1) return;
                var _index = $this.ProjectTeam.indexOf(item);
                $this.ProjectTeam.splice(_index, 1);
item.ProjectParticipant = null;
}
static clearProjectTeam = ($this) => { $this.ProjectTeam = null; }
static setProjectPayments = ($this, items) => {
                if (items == null) items = [];
                if ($this.ProjectPayments == null) $this.ProjectPayments = [];

                const copyItems = Common.cloneObject(items);

                while ($this.ProjectPayments.length > 0) {
                    Domain.ProjectParticipant.removeProjectPayments($this, $this.ProjectPayments[0]);
                }

                Domain.ProjectParticipant.addManyProjectPayments($this, copyItems);
            }
static addManyProjectPayments = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.ProjectParticipant.addProjectPayments($this, items[i]);
                }
            }
static addProjectPayments = ($this, item) => {
                if ($this.ProjectPayments == null) $this.ProjectPayments = [];
                if (item == null || $this.ProjectPayments.indexOf(item) > -1) return;
                $this.ProjectPayments.push(item);
if (item.Beneficiary != $this) {
Domain.ProjectPayment.setBeneficiary(item, $this);
}
}
static addRangeProjectPayments = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.ProjectParticipant.addProjectPayments($this, item));
            }
static removeProjectPayments = ($this, item) => {
                if ($this == null || $this.ProjectPayments == null || $this.ProjectPayments.indexOf(item) === -1) return;
                var _index = $this.ProjectPayments.indexOf(item);
                $this.ProjectPayments.splice(_index, 1);
item.Beneficiary = null;
}
static clearProjectPayments = ($this) => { $this.ProjectPayments = null; }
static setTrips = ($this, items) => {
                if (items == null) items = [];
                if ($this.Trips == null) $this.Trips = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Trips.length > 0) {
                    Domain.ProjectParticipant.removeTrips($this, $this.Trips[0]);
                }

                Domain.ProjectParticipant.addManyTrips($this, copyItems);
            }
static addManyTrips = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.ProjectParticipant.addTrips($this, items[i]);
                }
            }
static addTrips = ($this, item) => {
                if ($this.Trips == null) $this.Trips = [];
                if (item == null || $this.Trips.indexOf(item) > -1) return;
                $this.Trips.push(item);
if (item.Beneficiary != $this) {
Domain.Trip.setBeneficiary(item, $this);
}
}
static addRangeTrips = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.ProjectParticipant.addTrips($this, item));
            }
static removeTrips = ($this, item) => {
                if ($this == null || $this.Trips == null || $this.Trips.indexOf(item) === -1) return;
                var _index = $this.Trips.indexOf(item);
                $this.Trips.splice(_index, 1);
item.Beneficiary = null;
}
static clearTrips = ($this) => { $this.Trips = null; }

static CalculateCostsLinearProjectionFactor($this: any, projectMonth: any): any{let participantEntryMonth = (CLMS.Framework.Number.GreaterThan(() => $this.EntryMonth, () => 0) ? $this?.EntryMonth : 1);
let participantExitMonth = (CLMS.Framework.Number.GreaterThan(() => $this.ExitMonth, () => 0) ? $this?.ExitMonth : $this?.Project?.Duration);
let startForLinear = participantEntryMonth;
let endForLinear = Math.min(projectMonth, participantExitMonth);
let participantDuration = Joove.Common.safeNumber(participantExitMonth) - Joove.Common.safeNumber(participantEntryMonth) + Joove.Common.safeNumber(1);
let linearConsumptionFactor = Joove.Common.safeNumber((parseFloat(((Joove.Common.safeNumber(endForLinear) - Joove.Common.safeNumber(startForLinear) + Joove.Common.safeNumber(1))) as any))) / Joove.Common.safeNumber((parseFloat((participantDuration) as any)));
return linearConsumptionFactor;
}
static CalculateTargetEffortForPeriod($this: any, start: any,end: any): any{start = moment([moment(start).year(), ((moment(start).month() + 1)) - 1, 1]).toDate();
end = moment([moment(end).year(), ((moment(end).month() + 1)) - 1, 1]).toDate();
end = (moment((moment(end).add(1, "M")).toDate()).add(-1, "d")).toDate();
let targetedPeriodStart = Domain.Project.GetProjectMonthByDate($this?.Project, start);
if ((CLMS.Framework.Number.GreaterThan(() => $this.EntryMonth, () => 0))) {targetedPeriodStart = Math.max(targetedPeriodStart, $this?.EntryMonth);}
let targetedPeriodEnd = Domain.Project.GetProjectMonthByDate($this?.Project, end);
if ((CLMS.Framework.Number.GreaterThan(() => $this.ExitMonth, () => 0))) {targetedPeriodEnd = Math.min(targetedPeriodEnd, $this?.ExitMonth);}
let targetEffortForPeriod = 0.0;
let workAssignments = (CLMS.Framework.Number.GreaterThan(() => $this.WorkAssignments.linq.count((a) => a.Task != null && CLMS.Framework.Number.GreaterThan(() => a.Effort, () => 0)), () => 0) ? $this?.WorkAssignments?.linq?.where((a) => a?.Task != null)?.toArray() : $this?.WorkAssignments?.linq?.where((a) => a?.Task == null)?.toArray());
for (let _iwork = 0; _iwork < (workAssignments == null ? 0 : workAssignments.length); _iwork++) {let work = workAssignments[_iwork];let workTotalEffort = work?.Effort;let workStartMonth = (work?.Task != null ? work?.Task?.StartMonth : work?.WorkPackage?.StartMonth);let workEndMonth = (work?.Task != null ? work?.Task?.EndMonth : work?.WorkPackage?.EndMonth);if ((CLMS.Framework.Number.Equal(() => workStartMonth, () => 0) || CLMS.Framework.Number.Equal(() => workEndMonth, () => 0))) {console.debug(CLMS.Framework.String.Format("Project: {0}, Participant: {1}, work: {2}, start: {3}, end: {4}. Ignoring because start or end are null...", $this?.Project?.Acronym, $this?.ShortName, (work?.Task != null ? work?.Task?.Number : work?.WorkPackage?.Name), workStartMonth, workEndMonth));continue;}let workTotalDurationInMonths = Joove.Common.safeNumber(workEndMonth) - Joove.Common.safeNumber(workStartMonth) + Joove.Common.safeNumber(1);let workTargetEffortPerMonth = Joove.Common.safeNumber(workTotalEffort) / Joove.Common.safeNumber(workTotalDurationInMonths);for (var currMonth = targetedPeriodStart; CLMS.Framework.Number.LessThanOrEqual(() => currMonth, () => targetedPeriodEnd); currMonth = Joove.Common.safeNumber(currMonth) + Joove.Common.safeNumber(1)) {
if ((work?.Task != null && !(Domain.ProjectTask.IsActiveInProjectMonth(work?.Task, currMonth)))) {continue;}if ((work?.WorkPackage != null && !(Domain.WorkPackage.IsActiveInProjectMonth(work?.WorkPackage, currMonth)))) {continue;}targetEffortForPeriod = Joove.Common.safeNumber(targetEffortForPeriod) + Joove.Common.safeNumber(workTargetEffortPerMonth);}
}
return targetEffortForPeriod;
}
static GetCaption($this: any): any{return CLMS.Framework.String.Format("{0} - {1}", $this?.ParticipantNumber, $this?.ShortName);
}
static GetEntryMonth($this: any): any{if (($this?.EntryDate != null)) {return Domain.Project.GetProjectMonthByDate($this?.Project, $this?.EntryDate);}else {return 1;}
}
static GetExitMonth($this: any): any{if (($this?.ExitDate != null)) {return Domain.Project.GetProjectMonthByDate($this?.Project, $this?.ExitDate);}else {return $this?.Project?.Duration;}
}
static GetIndirectCosts($this: any): any{let rate = 0.25;
if (($this?.Project != null && CLMS.Framework.Number.GreaterThan(() => $this.Project.IndirectCostsPercentage, () => 0))) {rate = $this?.Project?.IndirectCostsPercentage;}
let baseAmount = 0;
if (($this?.Project == null)) {baseAmount = Joove.Common.safeNumber($this?.PersonnelCosts) + Joove.Common.safeNumber($this?.OtherDirectCosts);}else {switch (($this?.Project?.IndirectCostsBase)) {case Domain.IndirectCostsBaseEnum.ELIGIBLE_DIRECT_COSTS_EXCL_SUBCONTRACTING:
{
baseAmount = Joove.Common.safeNumber($this?.PersonnelCosts) + Joove.Common.safeNumber($this?.OtherDirectCosts);break;}
case Domain.IndirectCostsBaseEnum.ALL_ELIGIBLE_DIRECT_COSTS:
{
baseAmount = Joove.Common.safeNumber($this?.PersonnelCosts) + Joove.Common.safeNumber($this?.OtherDirectCosts) + Joove.Common.safeNumber($this?.SubcontractingCosts) + Joove.Common.safeNumber($this?.OtherCostCategories);break;}
case Domain.IndirectCostsBaseEnum.ELIGIBLE_DIRECT_COSTS_EXCL_SUBCONTRACTING_AND_3RD_PARTY:
{
throw Error("Not implemented ELIGIBLE_DIRECT_COSTS_EXCL_SUBCONTRACTING_AND_3RD_PARTY!");}
default:
{
baseAmount = Joove.Common.safeNumber($this?.PersonnelCosts) + Joove.Common.safeNumber($this?.OtherDirectCosts);break;}
}}
return Joove.Common.mathRound(Joove.Common.safeNumber(rate) * Joove.Common.safeNumber(baseAmount), 2);
}
static GetMaxEUContribution($this: any): any{return Joove.Common.safeNumber($this?.TotalEstimatedEligibleCosts) * Joove.Common.safeNumber($this?.FundingRate);
}
static GetOtherDirectCosts($this: any): any{return Joove.Common.safeNumber($this?.OtherDirectCosts_TravelCosts) + Joove.Common.safeNumber($this?.OtherDirectCosts_Equipment) + Joove.Common.safeNumber($this?.OtherDirectCosts_OtherGoods);
}
static GetParticipantNumberDecimal($this: any): any{let numText = Joove.Common.replaceAll(Joove.Common.replaceAll($this?.ParticipantNumber, ',', '.'), '-', '.');
try {let num = CLMS.Framework.Decimal.Parse(numText);return num;}
catch (x) {console.warn("Error parsing participant number: " + $this?.ParticipantNumber);return 0;}
}
static GetPersonnelCosts($this: any): any{return Joove.Common.safeNumber($this?.PersonnelCosts_A1A2A3_actuals) + Joove.Common.safeNumber($this?.PersonnelCosts_A1A2A3_unit) + Joove.Common.safeNumber($this?.PersonnelCosts_A4_unit);
}
static GetSponsor($this: any): any{let sponsor = $this?.ProjectTeam?.linq?.where((a) => a?.MainRole == Domain.ProjectTeamMemberRole.Sponsor)?.firstOrDefault(null);
return (sponsor == null ? null : sponsor?.Employee?.EmployeeAndOrg);
}
static GetTotalEffort($this: any): any{return $this?.WorkAssignments?.linq?.where((a) => a?.WorkPackage != null)?.toArray()?.linq?.sum((a) => a?.Effort);
}
static GetTotalEstimatedEligibleCosts($this: any): any{return Joove.Common.safeNumber($this?.PersonnelCosts) + Joove.Common.safeNumber($this?.SubcontractingCosts) + Joove.Common.safeNumber($this?.OtherDirectCosts) + Joove.Common.safeNumber($this?.OtherCostCategories) + Joove.Common.safeNumber($this?.IndirectCosts) + Joove.Common.safeNumber($this?.LumpSumCosts);
}
static IsActiveDuringPeriod($this: any, periodStart: any,periodEnd: any): any{let participationStartDate = Domain.Project.GetMonthDates($this?.Project, $this?.EntryMonth)?.linq?.where()?.firstOrDefault(null);
let participationEndDate = Domain.Project.GetMonthDates($this?.Project, $this?.ExitMonth)?.linq?.where()?.firstOrDefault(null);
return Domain.Util.DoMonthPeriodsOverlap(new Date(new Date(periodStart)?.setHours(0, 0, 0, 0)), new Date(new Date(periodEnd)?.setHours(0, 0, 0, 0)), participationStartDate, participationEndDate);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}